import React, { useState } from 'react';
import './ShippingPreview.css';
import { DataGrid } from '@mui/x-data-grid';
import { FormPane } from "../../../components/FormZero/PageComponents/FormPane/FormPane";
import { Subject } from "rxjs";
import * as XLSX from 'xlsx';
import { DebugView } from "../../../components/FormZero/DebugView/DebugView";
import axios from "axios";
import { Dialog, DialogTitle, DialogContent, DialogActions, FormControl, ThemeProvider, createTheme, Button, Unstable_Grid2 as Grid } from '@mui/material';
import { InputLabel, MenuItem, Select } from "@mui/material";
import { CustomDataGrid } from '../../../components/StripedDataGrid';
import SearchChips from '../../../components/SearchChips';
import { ISearchChips } from '../../../interfaces/Core/ISearchChips';
import { IShipment, IShipments } from '../../../interfaces/Shipping/IShipment';

const weekList = [];
for (let i = 0; i < 53; i++) {
    weekList.push({ label: `Week ${i + 1}`, value: `${i + 1}` });
}

const PossibleRoutes = [
    "FedEx",
    "Grower Truck",
    "UPS",
    "Palletized",
    "Customer Pickup",
    "OVN VAN"
];

function ChangeRouteModal(props: any) {
    const { handleClose, saveRouteChange } = props;

    const [selectedRoute, setSelectedRoute] = React.useState("");
    // const PossibleRoutes = [
    //     "Grower BoxOrders",
    //     "FedEx"
    // ];

    return (<>
        <Dialog
            open={true}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{"Select Route"}</DialogTitle>
            <DialogContent style={{ width: '300px' }}>
                <div>
                    <FormControl variant={'outlined'} fullWidth margin="dense" sx={{minWidth: '100%'}}>
                        <InputLabel shrink id="selected-route-label">Selected Route</InputLabel>
                        <Select
                            labelId="selected-route-label"
                            id="selected-route-select"
                            value={selectedRoute}
                            label="Selected Route"
                            onChange={(e) => setSelectedRoute(e.target.value)}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {PossibleRoutes.map((route) => (<MenuItem key={route} value={route}>{route}</MenuItem>))}
                        </Select>
                    </FormControl>
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='contained'
                    className="btn btn-primary"
                    onClick={handleClose}
                    fullWidth
                >
                    Cancel
                </Button>
                <Button
                    variant='contained'
                    fullWidth
                    color='secondary'
                    className="btn btn-primary"
                    disabled={selectedRoute === ""}
                    onClick={() => saveRouteChange(selectedRoute)}
                >
                    Set Route
                </Button>
            </DialogActions>
        </Dialog>
    </>);
}

export function ShippingPreview(props: any) {
    // const {} = props;

    const [rows, setRows] = useState<any>([]);
    const [selectionModel, setSelectionModel] = useState<any>([]);
    const [showRouteSelectionModal, setShowRouteSelectionModal] = React.useState<any>(false);
    const [formFilter, setFormFilter] = React.useState<any>({});

    const getShipments = async () => {
        let outputRows: any[] = [];
        const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Shipments/`); //${weekObj.week}/${weekObj.year}
        console.log(response);
        if (response.status === 200) {
            // TODO: refresh the table on the main page? or location.reload
            console.log(response);
            outputRows = [...outputRows, ...response.data]
        }
        setRows(outputRows);




        // if (formFilter === undefined || formFilter === null || formFilter['week_year'] === undefined || formFilter['week_year'] === null || formFilter['week_year'] === "") {
        //     setRows([]);
        //     return;
        // }
        // setRows([])
        // return ;

        // console.log("GetListOfPatchingToBeDoneFromServer");
        // try {

        //     let outputRows: any[] = [];
        //     await formFilter['week_year'].forEachAsync(async (weekObj: { week: any; year: any; }) => {
        //         console.log(weekObj);
        //         // const [year, week] = weekObj.split("-");
        //         const response = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Shipments/`); //${weekObj.week}/${weekObj.year}
        //         console.log(response);
        //         if (response.status === 201) {
        //             // TODO: refresh the table on the main page? or location.reload
        //             console.log(response);
        //             outputRows = [...outputRows, ...response.data]
        //         }
        //     });
        //     setRows(outputRows);
        // } catch (err) {
        //     console.log(err);
        // }
    }

    // const getShipments = async () => {
    //     try {
    //         let response = await axios.get('/shipping/shipments');
    //         setRows(response.data);
    //
    //         // TODO filter by the filter values
    //
    //     } catch (e) {
    //         console.error(e);
    //     }
    // };
    const uploadNewData = async (data: ({} | undefined)[]) => {
        console.log("SHIPMENT DATA", data);
        var shipments: IShipments = [];
        data.forEach((element: any) => {
            console.log(element);
            shipments.push({
                id: 0,
                orderNumber: `${element['Order#']}`,
                customerName: `${element['Customer Name']}`,
                city: `${element['City']}`,
                state: `${element['St']}`,
                zip: `${element['Zip']}`,
                airportCode: `${element['Airport Code']}`,
                boxes: `${element['Boxes']}`,
                phone: `${element['Phone']}`,
                salesRep: `${element['Sales Rep']}`,
                shipWeek: `${element['Ship Week']}`,
                shipDate: new Date(), //TODO CALCULATE DATE?
                shipCondition: `${element['ShpCond']}`,
            });
        });
        console.log("SHIPMENTS", shipments)
        try {
            let response = await axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Shipments/UploadShipments`, shipments);
            console.log(response);
            await getShipments();
        } catch (e) {
            console.error(e);
        }
    };
    const updateExistingData = async (route: any) => {
        console.log("SELECTION MODEL", selectionModel);
        var shipments = rows.filter((x:any) => {return selectionModel.includes(x.id)})
        console.log(shipments);
        // try {
        //     let response = await axios.put(`${process.env.REACT_APP_ENDPOINT}/api/Shipments`, { selection_list: selectionModel, route: route });
        //     console.log(response);
        //     await getShipments();
        //     setShowRouteSelectionModal(false);
        //     setSelectionModel([]);
        // } catch (e) {
        //     console.error(e);
        // }
    };
    React.useEffect(() => {
        getShipments().then();
    }, [formFilter['week_year']]);


    function downloadXLSX() {

        const ws = XLSX.utils.json_to_sheet(rows.map((r: any) => {
            delete r['id'];
            r['Shp.Cond.'] = r['ShpCond'];
            delete r['ShpCond'];
            return r;
        }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Export');

        XLSX.writeFile(wb, "Export.xls"); // <-- just do it this way.
    }

    function readXLSX() {
        let input = document.createElement('input');
        input.type = 'file';
        input.onchange = _ => {
            // you can use this method to get file and perform respective operations
            let files = Array.from(input.files!);
            console.log(files);
            if (files.length > 0) {
                // const name = files[0].name;
                const reader = new FileReader();
                reader.onload = (evt) => { // evt = on_file_select event
                    /* Parse data */
                    const bstr = evt.target != null ? evt.target.result : null;
                    const wb = XLSX.read(bstr, { type: 'binary' });
                    // const wb = XLSX.read(bstr, {type:'string'});
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    const json = XLSX.utils.sheet_to_json(ws, { header: 1 });
                    console.log(json);

                    const spLines = [...json];
                    const line1: any = spLines[0];
                    spLines.shift();
                    const output = spLines.map((line: any, lineNum: any) => {
                        let obj: any = {};
                        obj['id'] = `line_${lineNum}`;
                        console.log(line);
                        if (line.length > 1) {
                            line.forEach((elm: any, index: string | number) => {
                                let key = line1[index];
                                let value = line[index];
                                obj[key] = value;
                            })
                        } else {
                            return undefined;
                        }
                        return obj;
                    }).filter((o) => o !== undefined);
                    const trueOutput = output.map((o) => {
                        o['ShpCond'] = o['Shp.Cond.'];
                        delete o['Shp.Cond.'];
                        return o;
                    });
                    console.log(trueOutput);
                    // setRows(trueOutput);
                    // TODO: make this save to database.....!!!!!
                    uploadNewData(trueOutput).then();
                };
                reader.readAsBinaryString(files[0]);
            }
        };
        input.click();
    }

    const columns = [
        // { field: 'id', headerName: 'ID', width: 90 },
        { field: 'orderNumber', headerName: 'Order #', width: 200 },
        { field: 'customerName', headerName: 'Customer Name', width: 200 },
        { field: 'city', headerName: 'City', width: 200 },
        { field: 'state', headerName: 'State', width: 200 },
        { field: 'Route', headerName: 'Route', width: 200 },
        { field: 'boxes', headerName: 'Boxes', width: 200 },
        { field: 'trays', headerName: 'Trays', width: 200, valueGetter: (cellValues: { row: { [x: string]: number; }; }) => (cellValues.row['boxes'] * 4) },
        { field: 'zip', headerName: 'Zip', width: 200 },
        { field: 'airportCode', headerName: 'Airport Code', width: 200 },
        { field: 'phone', headerName: 'Phone Number', width: 200 },
        { field: 'salesRep', headerName: 'Sales Rep', width: 200 },
        { field: 'shipWeek', headerName: 'Ship Week', width: 200 },
        { field: 'shipCondition', headerName: 'Ship Condition', width: 200 },
    ];

    const formSubject = new Subject();
    formSubject.subscribe((n) => setFormFilter(n));

    const formStructure = [
        {
            size: {
                default: 2
            },
            type: "button",
            label: "Select Route",
            clickHandler: () => {
                if (selectionModel.length > 0) {
                    setShowRouteSelectionModal(true)
                }
            }
        },
        {
            size: {
                default: 2
            },
            type: "button",
            label: "Upload",
            clickHandler: () => {
                readXLSX();
            }
        },
        {
            size: {
                default: 2
            },
            type: "button",
            label: "Export",
            clickHandler: () => {
                // alert("Export Not implemented yet");
                downloadXLSX();
            }
        },
    ];

    const darkTheme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#89B219',
            },
        },
    });

    const [searchInformation, setSearchInformation] = React.useState<ISearchChips>();

    const handleSearchChips = (searchInformation: ISearchChips) => {
        setSearchInformation(searchInformation);
    }

    return (
        <>
            <div className="ShippingPreview">
                <div className="card">
                    <div className="card-body">
                        <ThemeProvider theme={darkTheme}>
                            <SearchChips handleSearch={handleSearchChips}></SearchChips>
                        </ThemeProvider>
                        <FormPane formStructure={formStructure} formSubject={formSubject} />
                    </div>
                </div>

                <CustomDataGrid
                    style={{ "width": "100%", 'maxWidth': '100%', 'height': '70vh' }}
                    rows={rows}
                    columns={columns}
                    rowsPerPageOptions={[5, 10]}
                    checkboxSelection={true}
                    disableSelectionOnClick
                    selectionModel={selectionModel}
                    onSelectionModelChange={(m) => setSelectionModel(m)}
                />
            </div>

            {(showRouteSelectionModal) && (<ChangeRouteModal handleClose={() => setShowRouteSelectionModal(false)} saveRouteChange={updateExistingData} />)}
        </>
    )
}
